import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 2 — Preambulo + Indice. El indice se arma dinamicamente a partir
// de la lista de paginas activas (props tocItems = [{ romano, titulo, pag }, ...]).
export default function PreambuloPage({ config, pagNum, pagTotal, tocItems }) {
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">00 · Preámbulo</span>
        <h2 className="big">Marco normativo de <em>convivencia.</em></h2>
        <p className="lead">
          Este Reglamento regirá los derechos y obligaciones de los copropietarios, promitentes compradores y ocupantes de las unidades y bienes comunes del Edificio {config.edificio}. Se aplica en concordancia con el Reglamento de Copropiedad y las Leyes 10.751, 14.560, modificativas, concordantes y decretos reglamentarios.
        </p>

        <span className="sec-tag" style={{ marginTop: 30, display: "inline-flex" }}>Índice</span>
        <div className="toc-grid">
          {tocItems.map((it) => (
            <div key={it.romano} className="toc-row">
              <span className="n">{it.romano}</span>
              <span className="t">{it.titulo}</span>
              <span className="p">{String(it.pag).padStart(2, "0")}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
